function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
import flatpickr from 'flatpickr/dist/flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import tippy from 'tippy.js';
export var utils = new ( /*#__PURE__*/function () {
  function Utils() {
    var _this = this;
    _classCallCheck(this, Utils);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(Utils, [{
    key: "init",
    value: function init() {
      vent.on('PCS:REFRESH_UI', this.refreshUi.bind(this));
      vent.publish('PCS:REFRESH_UI');
    }
  }, {
    key: "refreshUi",
    value: function refreshUi() {
      this.refreshEditors();
      this.refreshDateInputs();
      this.refreshTooltips();
    }
  }, {
    key: "refreshEditors",
    value: function refreshEditors() {
      if (window.ClassicEditor) {
        $('[data-editor]').each(function () {
          var textarea = $(this)[0];
          if (!textarea.getAttribute('data-wysiwyg')) {
            textarea.setAttribute('data-wysiwyg', true);
            ClassicEditor.create(textarea, {}).then(function (editor) {
              // console.log(editor);
            })["catch"](function (error) {
              // console.error(error);
            });
          }
        });
      }
    }
  }, {
    key: "refreshDateInputs",
    value: function refreshDateInputs() {
      $('input[type="date"]').each(function (e) {
        var input = $(this)[0];
        if (!input.getAttribute('data-datepicker')) {
          input.setAttribute('data-datepicker', true);
          $(this).flatpickr({
            enableTime: true,
            locale: 'fr',
            minuteIncrement: 1,
            hourIncrement: 1,
            minDate: 'today',
            altFormat: 'd/m/Y H:i',
            dateFormat: 'Y-m-d H:i',
            altInput: true //
          });
        }
      });
    }
  }, {
    key: "refreshTooltips",
    value: function refreshTooltips() {
      $('[data-toggle="tooltip"]').each(function (e) {
        var button = $(this)[0];
        if (!button.getAttribute('data-tooltip-ok')) {
          button.setAttribute('data-tooltip-ok', true);
          var tooltip = $('#' + $(this).attr('aria-describedby'))[0];
          tippy(button, {
            content: tooltip ? tooltip.innerHTML : button.getAttribute('title') || button.getAttribute('aria-label'),
            appendTo: function appendTo() {
              return document.body;
            },
            allowHTML: true,
            interactive: true,
            delay: 200,
            animation: false,
            trigger: button.getAttribute('data-click') ? 'click' : 'mouseenter focus',
            popperOptions: {
              modifiers: [{
                name: 'preventOverflow',
                options: {
                  boundary: document
                }
              }]
            }
          });
        }
      });
    }
  }]);
  return Utils;
}())();